import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Site } from '@classes/site';

@Injectable({
  providedIn: 'root'
})
export class SitesService {
    sitesListChanged = new Subject<Site[]>();
    private baseUrl: string = environment.apiUrl + 'sites';
    private sites: Site[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<Site[]> {
        return this.http.get<Site[]>(this.baseUrl)
        .pipe(
            map(sites => {
                this.sites = sites.map(c => Site.fromObject(c));
                this.sites.sort((a, b) => a.name.localeCompare(b.name));
                this.sitesListChanged.next([ ...this.sites ]);
                return [ ...this.sites ];
            })
        );
    }

    getListByClients(ids: string[]): Observable<Site[]> {
        return this.http.get<Site[]>(`${this.baseUrl}?clientIds=${ids}`)
        .pipe(
            map(sites => {
                this.sites = sites.map(c => Site.fromObject(c));
                this.sitesListChanged.next([ ...this.sites ]);
                return [ ...this.sites ];
            })
        );
    }

    put(site: Site): Observable<Site> {
        return this.http.put<Site>(this.baseUrl, site)
        .pipe(
            tap(editedSite => {
                editedSite = Site.fromObject(editedSite);
                this.sites = this.sites.map(c => c.id === editedSite.id ? editedSite : c);
                this.sitesListChanged.next([ ...this.sites ]);
            })
        );
    }

    post(site: Site): Observable<Site> {
        return this.http.post<Site>(this.baseUrl, site)
        .pipe(
            tap(createdSite => {
                createdSite = Site.fromObject(createdSite);
                this.sites.push(createdSite);
                this.sitesListChanged.next([ ...this.sites ]);
            })
        );
    }

    delete(id: string): Observable<void> {
      return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
          tap(() => {
              this.sites = this.sites.filter(m => m.id !== id);
              this.sitesListChanged.next([ ...this.sites ]);
          })
      );
  }
}
